import { fetchTimetableData } from "./fetchTimetableData";

export const timetableMiddleware = (store) => (next) => (action) => {
  const previousType = store.getState().timetable?.type;
  const result = next(action);

  if (
    action.type === 'timetable/toggleFilter' ||
    action.type === 'timetable/resetFilter'  ||
    action.type === 'timetable/setWeekRange' ||
    action.type === 'timetable/setMonthRange' ||
    action.type === 'timetable/setDay'       ||
    action.type === 'timetable/setType'      ||
    action.type === 'timetable/setPeriodMode' ||
    action.type === 'timetable/setTimeZoneEnabled'
  ) {
    store.dispatch(fetchTimetableData());
  } else if (
    // Тип расписания пересчитывается и при обновлении профиля (extraReducers в timetableSlice).
    // Ответ запроса со старым типом fetchTimetableData отбрасывает, не снимая загрузку,
    // поэтому без нового запроса страница остаётся на спиннере.
    // resetState не трогаем: за ним всегда следует явный fetchTimetableData.
    action.type !== 'timetable/resetState' &&
    store.getState().timetable?.type !== previousType
  ) {
    store.dispatch(fetchTimetableData());
  }

  return result;
};
